import classNames from "classnames";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";

import classes from "./CheckedCircle.module.less";

type Props = {
  checked?: boolean;
  className?: string;
  legacy?: boolean;
  alwaysVisible?: boolean;
} & Omit<JSX.IntrinsicElements["div"], "children">;

export const CheckedCircle = ({ checked, className, legacy = true, alwaysVisible, ...rest }: Props) => {
  const cls = classNames(
    classes.root,
    checked && classes.checked,
    className,
    legacy && "scha__lc__card__checkmark",
    alwaysVisible && classes.alwaysVisible
  );
  return (
    <div className={cls} {...rest}>
      {checked && <Icon type={IconType.Check} className={"d-flex"} />}
    </div>
  );
};
